import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PermissionId } from '@/lib/permissions'

export type PermissionCodenameMap = Record<string, PermissionId>

type PermissionState = {
  allPermissionList: PermissionId[] | null
  codenameToId: PermissionCodenameMap | null
}

type PermissionAction = {
  setAllPermissionList: (data: PermissionId[]) => void
  setCodenameToId: (data: PermissionCodenameMap) => void
  clearAllPermissionList: () => void
}

export const usePermissionStore = create<PermissionState & PermissionAction>()(
  persist(
    (set) => ({
      allPermissionList: null,
      codenameToId: null,
      setAllPermissionList: (data) => set({ allPermissionList: data }),
      setCodenameToId: (data) => set({ codenameToId: data }),
      clearAllPermissionList: () => set({ allPermissionList: null, codenameToId: null }),
    }),
    {
      name: 'setu-permission-store',
      partialize: (state) => ({
        allPermissionList: state.allPermissionList,
        codenameToId: state.codenameToId,
      }),
    },
  ),
)
